import { render, staticRenderFns } from "./notification-permission-settings.vue?vue&type=template&id=31677c98&scoped=true"
import script from "./notification-permission-settings.vue?vue&type=script&lang=js"
export * from "./notification-permission-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31677c98",
  null
  
)

export default component.exports